import { Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ReactComponent as MediaIcon } from 'assets/icons/edit-image.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit-white.svg';
import { DrawerMedia, GridWrap, InfoWrapper, Table } from 'components';
import {
  FieldType,
  MediaGroup,
  SchemaPonteCommonTableValue,
  UploadMedia,
} from 'constants/inspections';
import { tipologiaParapettoOptions } from 'constants/selectOptions';
import { useInspectionPath } from 'hooks';
import { INFO } from 'pages/Inspections/config/info';
import { useInspectionSelector } from 'stores';
import ParapettiForm from './ParapettiForm';
const ParapettiSection = ({ selectedIdx }) => {
  const { watch, setValue, getValues } = useFormContext();
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();

  const sovrastrutturaImpalcatoTableParapettiTableWatch = watch(
    `sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable`
  );

  // table setup
  const dataConfigParapetti = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaParapetto: {
        label: 'Tipologia Parapetto',
        format: tipologiaParapettoOptions,
      },
      tipologiaAltroParapetto: {
        label: 'Tipologia Parapetto (Altro)',
      },

      altezzaParapetto: {
        label: 'H [cm]',
      },

      superficieParapetto: {
        label: 'S [m²]',
      },
    },
  };

  // parapetti setup
  const [selectedParapetti, setSelectedParapetti] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();

  const editRowsParapetti = item => {
    setValue('l0t3a2_parapettiTableValue', [item]);
    setValue('l0t3a2_tipologiaParapettoTableValue', item.tipologiaParapetto);
    setValue(
      'l0t3a2_tipologiaAltroParapettoTableValue',
      item.tipologiaAltroParapetto
    );
    setValue('l0t3a2_altezzaParapettoTableValue', item.altezzaParapetto);
    setValue('l0t3a2_superficieParapettoTableValue', item.superficieParapetto);
  };
  const handleSelectAllClickParapetti = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable`
      );
      const filteredValue = selectedValue.filter(
        el => el.presenza === SchemaPonteCommonTableValue.Uno
      );
      setSelectedParapetti(filteredValue);
      setValue('l0t3a2_parapettiTableValue', filteredValue);
    } else {
      setSelectedParapetti([]);
      setValue('l0t3a2_parapettiTableValue', []);
    }
  };

  return (
    <>
      <InfoWrapper
        isDivider={true}
        size={12}
        infoDrawer={true}
        drawerTitle={INFO.impalcatoParapetti.drawerTitle}
        drawerText={INFO.impalcatoParapetti.drawerText}
      >
        <Divider sx={{ marginTop: 3 }}>PARAPETTI</Divider>
      </InfoWrapper>
      {sovrastrutturaImpalcatoTableParapettiTableWatch?.length === 0 && (
        <GridWrap item xs={12}>
          <Typography>Nessun parapetto previsto in questo elemento</Typography>
        </GridWrap>
      )}
      {sovrastrutturaImpalcatoTableParapettiTableWatch?.every(
        el => el.assente
      ) &&
        sovrastrutturaImpalcatoTableParapettiTableWatch?.length > 0 && (
          <GridWrap item xs={12}>
            <Typography>
              Nessun parapetto presente in questo elemento
            </Typography>
          </GridWrap>
        )}
      {sovrastrutturaImpalcatoTableParapettiTableWatch?.filter(
        el => !el.assente
      ).length > 0 && (
        <>
          {!inspectionDisabled && !isViewingInspection && (
            <ParapettiForm
              parapettiFields={
                sovrastrutturaImpalcatoTableParapettiTableWatch || []
              }
              selected={selectedParapetti}
              setSelected={setSelectedParapetti}
              parapettiTable={`sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable`}
              selectedIdx={selectedIdx}
            />
          )}
          <DrawerMedia
            open={open}
            setOpen={setOpen}
            title={'Parapetti'}
            infoPanel="Per un'ottimizzazione nel report, si consiglia di eseguire foto in orizzontale in rapporto 4:3."
            dataType="video/*,image/*"
            uploadType={UploadMedia.media}
            type={FieldType.images}
            formName={`sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable[${drawerMediaIndex}].media`}
            mediaGroup={[MediaGroup.Sovrastruttura]}
          />
          <GridWrap container spacing={2} mt={2}>
            <GridWrap item xs={12}>
              <Table
                data={
                  sovrastrutturaImpalcatoTableParapettiTableWatch.filter(
                    el => !el.assente
                  ) || []
                }
                config={dataConfigParapetti}
                hasCheckbox={!inspectionDisabled && !isViewingInspection}
                rowActions={
                  !inspectionDisabled && !isViewingInspection
                    ? [
                        {
                          onClick: item => {
                            editRowsParapetti(item);
                            setSelectedParapetti([item]);
                          },
                          icon: <EditIcon />,
                        },
                      ]
                    : []
                }
                mediaActions={[
                  {
                    onClick: item => {
                      setDrawerMediaIndex(
                        sovrastrutturaImpalcatoTableParapettiTableWatch.findIndex(
                          el => el.id === item.id
                        )
                      );
                      setOpen(true);
                    },
                    icon: <MediaIcon />,
                  },
                ]}
                selected={selectedParapetti}
                onSelectAllClick={handleSelectAllClickParapetti}
                setSelected={setSelectedParapetti}
              />
            </GridWrap>
          </GridWrap>
        </>
      )}
    </>
  );
};
ParapettiSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default ParapettiSection;
